// extracted by mini-css-extract-plugin
export default {"commonHeader":"styles_commonHeader__Hun5x","sellerHeader":"styles_sellerHeader__QIiba","buyerHeader":"styles_buyerHeader__FRlxi","border":"styles_border__opjFD"};